import { AfterViewInit, Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Store } from '@ngrx/store';
import { I18NextPipe } from 'angular-i18next';
import { Observable, Subject, Subscription, interval } from 'rxjs';
import { report } from 'src/app/dashboards/models';
import { State } from 'src/app/dashboards/state';
import { register } from 'src/app/dashboards/widget/widget-helpers/helpers';
import { widgetType } from 'src/app/enums';
import { gridItem } from 'src/app/models';
import { CommonService } from 'src/app/services/services/common.service';
import { DashboardService } from 'src/app/services/services/dashboard.service';
import { WidgetBaseComponent } from '../../widget-base.component';
import { takeUntil } from 'rxjs/operators';

@Component({
    selector: 'app-rule-match',
    templateUrl: './rule-match.component.html',
    styleUrls: ['./rule-match.component.scss'],
    standalone: false
})

@register("RuleMatch")
export class RuleMatchComponent implements OnInit, OnDestroy, WidgetBaseComponent, AfterViewInit {
  @Input() public isInWizard: boolean;
  @Input() public report: report | any;
  @Input() isReportModified: boolean;
  @Input() canExport: boolean;
  @Input() viewReportObservable$: Observable<any>;
  @Input() orderColumnsObservable$: Observable<void>;
  @Input() dataLoadingObservable$: Observable<boolean>;
  @Input() public downloadDialogNotifier: Subject<any>;
  @Input() public isStandAlone: boolean;
  @Input() public reportInfo: string;

  _gridItem: gridItem;
  get gridItem(): gridItem {
    return this._gridItem;
  }
  @Input() set gridItem(value: any) {
    this._gridItem = value;
    setTimeout(() => {
      this.notifier.next();
    }, 0);
  }

  // used in the Dashboard
  _dataEquality: boolean;
  get dataEquality(): boolean {
   return this._dataEquality;
  }

    // used in the Dashboard
  @Input() set dataEquality(value: boolean) {
   this._dataEquality = value;
   if (!value) {
     this.getData();
   }
  }

  _colorSchemeId: number;
  get colorSchemeId(): number {
    return this._colorSchemeId;
  }
  @Input() set colorSchemeId(value: number) {
    this._colorSchemeId = value;
  }

  @Output() public reportExpandedNotifier = new EventEmitter<boolean>();
  @Output() public refreshNotifier = new EventEmitter<boolean>();
  @Output() public showColumnButtonNotifier = new EventEmitter<boolean>();
  @Output() public exportReportNotifier = new EventEmitter();

  public data: any[];
  public columns: any[];
  public terminate$ = new Subject<void>();
  public notifier: Subject<void> = new Subject<void>();
  generateNotifier = new Subject<void>();
  public type: string = "RuleMatch";
  public widgetType = widgetType;
  dataLoading: boolean = false;
  isTableVisible: boolean = true;

  private viewReportSubscription: Subscription;
  private orderColumnsSubscription: Subscription;
  private dataLoadingSubscription: Subscription;

  constructor(private dashboardsService: DashboardService, private store: Store<State>, private i18nextPipe: I18NextPipe, public dialog: MatDialog,
    private commonService: CommonService  ) { }

  ngOnInit(): void {
    this.viewReportSubscription = this.viewReportObservable$?.subscribe(obj => this.viewReport(obj));
    this.orderColumnsSubscription = this.orderColumnsObservable$?.subscribe(() => this.reorderCoulmns());
    this.dataLoadingSubscription = this.dataLoadingObservable$?.subscribe(isDataLoading => this.dataLoading = isDataLoading);
  }

  ngOnDestroy(): void {
    this.terminate$.next();
    this.terminate$.complete();
    this.viewReportSubscription?.unsubscribe();
    this.orderColumnsSubscription?.unsubscribe();
    this.dataLoadingSubscription?.unsubscribe();
  }

  ngAfterViewInit(): void {
    if (!this.isInWizard && !this.isStandAlone) {
      this.getData();
      interval(5 * 60 * 1000).pipe(takeUntil(this.terminate$)).subscribe(_ => { this.getData(); });
    }
  }

  viewReport({ data, columns }) {
    this.data = data;
    this.columns = columns;
    // this flag is determined here, so only when "View Report" button is clicked, the data visualization should be changed
    this.isTableVisible = this.gridItem.type === 4;

    setTimeout(() => {
      this.notifier.next();
      window.dispatchEvent(new Event('resize'));
    }, 0);
  }

  reorderCoulmns() {
    let columnIdsFromSettings: string[] = this.gridItem.setup.columns, newArray: any[] = [];

    this.columns.forEach(column => {
      let index = columnIdsFromSettings.indexOf(column.id);
      newArray[index] = column;
    });

    this.columns = newArray;
  }

  getData() {
    this.dataLoading = true;

    this.dashboardsService.getWebEngageReportResult(this.gridItem.setup).subscribe((result) => {
      let columnIdsFromSettings: string[] = this.gridItem.setup.columns;
      let data = result.data;
      let columns = columnIdsFromSettings.map(id => result.columns.find(c => c.id === id));
      if(result?.specialReportProp?.hideUniqueCount){
        columns = columns.filter(c => c.id !== "u_count");
      }

      this.dataLoading = false;
      this.viewReport({ data, columns });
    });
  }
}
